import Vue from "vue";
Vue.filter("hora", (value) => {
  if (value) {
    let dt = new Date(value);
    return `${dt.getHours()}:${dt.getMinutes()}`;
  }
});
